import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { Events,AlertController} from 'ionic-angular';

@Component({
  selector: 'image-renderer',
  templateUrl: 'image-renderer.html'
})
export class ImageRendererComponent implements ICellRendererAngularComp {
  cellValue: any;
  label: string;
  showPlay:boolean = true;
  showPreview:boolean = false;

  constructor(public events: Events, public alertCtrl:AlertController) { 
  }
  agInit(params: any): void {
    this.cellValue = params;
    this.label = params.value|| null;
    this.showPlay = true;
    if(this.cellValue.node.data["DocStatus"]=="Hold" || this.cellValue.node.data["DocStatus"]=="Completed"){
      this.showPlay = true;
    }else {
      this.showPlay = false;
    }
  }

  refresh(params?: any): boolean {
    this.cellValue = params;
    return true;
  }

  onClick(e) {
    
    if(this.showPlay == false){
      this.showPlay = true;
      this.cellValue.node.data["DocStatus"]="Hold";
    }else{
      this.showPlay = false;
      this.cellValue.node.data["DocStatus"]="In Progress";
    }
    let confirmAlert = this.alertCtrl.create({
      title: 'Status Update',
      message: 'Are you sure, Do you want to change the track '+ this.cellValue.node.data["DocStatus"]+ '?',
      buttons: [{
        text: 'Yes',
        handler: () => {
          if (this.cellValue.onClick instanceof Function) {
            // put anything into params u want pass into parents component
            const params = {
              event: e,
              rowData: this.cellValue.node.data,
              type: 'update',
              rowIndex: this.cellValue.rowIndex
              // ...something
            }
            this.cellValue.onClick(params);
          }
        }
      }, {
        text: 'No',
        role: 'cancel',
        handler: () => {
          
          if(this.showPlay == false){
            this.showPlay = true;
            this.cellValue.node.data["DocStatus"]="Hold";
          }else{
            this.showPlay = false;
            this.cellValue.node.data["DocStatus"]="In Progress";
          }
        }
      }]
    });
    confirmAlert.present();
    
}

  toggleOnButton(e){
    if(this.showPlay == false){
      this.showPlay = true;
    }else{
      this.showPlay = false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/agGridRenderer/image-renderer/image-renderer.ts